import axios from 'axios';

const API_URL = process.env.VUE_APP_API_URL;

export default new (class {
	async getAll(facilityId) {
		const response = await axios.get(
			`${API_URL}/api/Cms/SponsorLogos?facilityId=${facilityId}`,
			{
				withCredentials: true,
				headers: {
					'Cache-control': 'no-cache'
				}
			}
		);
		return response.data;
	}
	async getById(SponsorLogo_ID) {
		const url = SponsorLogo_ID
			? `/api/Cms/SponsorLogo?id=${SponsorLogo_ID}`
			: '/api/Cms/SponsorLogo';

		const response = await axios.get(`${API_URL}${url}`, {
			withCredentials: true,
			headers: {
				'Cache-control': 'no-cache'
			}
		});
		return response.data;
	}
	async update(SponsorLogosData) {
		try {
			await axios.put(`${API_URL}/api/Cms/SponsorLogo`, SponsorLogosData, {
				withCredentials: true,
				headers: {
					'Cache-control': 'no-cache'
				}
			});
		} catch (error) {
			console.error('Error updating lifestyle question:', error);
			throw error;
		}
	}
	async deleteById(SponsorLogo_ID) {
		try {
			await axios.delete(
				`${API_URL}/api/Cms/SponsorLogo?id=${SponsorLogo_ID}`,
				{
					withCredentials: true,
					headers: {
						'Cache-control': 'no-cache'
					}
				}
			);
		} catch (error) {
			console.error('Error deleting by ID:', error);
			throw error;
		}
	}
})();
